import { ref, reactive } from 'vue'
import { Assertion } from '@annto/fe-utils/lib/assertion'
import { useMessageCenter } from '@/message/useMessageCenter'

export function useAction(action) {
    const loading = ref(false)

    const loadingMap = reactive({})

    const run = async (...args) => {
        loading.value = true
        return action(...args)
            .catch(Assertion.reporter.w)
            .finally(() => {
                loading.value = false
            })
        }

        const runWith = key => {
            const run = async (...args) => {
                loadingMap[key] = true

                return action(...args)
                    .catch(Assertion.reporter.w)
                    .finally(() => {
                        loadingMap[key] = false
                    })
            }
            return {
                run,
                action: run,
            }
        }

    return {
        loading,
        loadingMap,
        loadingOf: key => loadingMap[key],
        run,
        action: run,
        of: runWith,
    }
}

const mc = useMessageCenter()
export function actionSuccess(message) {
    return () => {
        mc.postSuccess(message, '/modal')
    }
}

export function emitActionSuccess(message) {
    mc.postSuccess(message, '/modal')
}
